import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { ContentObjectTypes, getPropertyValue } from 'content-management-data-lib';
import { PAGE_PROPERTY_NAMES } from 'page-lib/constants/propertyNames';
import useContentObjectType from '../hooks/usePageContentObjectType';
import useMabExperiment from '../hooks/useMabExperiment';
import { getContentDynamicPageHubDbTableId } from '../utils/dynamicPageUtils';
import { getHubDbTableUrl } from '../utils/urls';
import useHubDbTable from '../hooks/useHubDbTable';
import useDynamicPageInfo from '../hooks/useDynamicPageInfo';
import useHubDbRows from '../hooks/useHubDbRows';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const MabVariantUrls = ({
  contentObject
}) => {
  const contentObjectType = useContentObjectType();
  const mabExperimentId = getPropertyValue(contentObject, PAGE_PROPERTY_NAMES.MAB_EXPERIMENT_ID);
  const {
    mabInfo
  } = useMabExperiment({
    mabExperimentId,
    isLandingPage: contentObjectType === ContentObjectTypes.LANDING_PAGE
  });
  if (!mabInfo) {
    return null;
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: Object.values(mabInfo.mabVariantsMap).map(({
      id,
      name,
      url
    }) => /*#__PURE__*/_jsx(Link, {
      external: true,
      href: url,
      truncate: true,
      children: name
    }, id))
  });
};
export const HubDbTable = ({
  contentObject
}) => {
  const dynamicPageHubDbTableId = getContentDynamicPageHubDbTableId(contentObject);
  const {
    hubDbTableId
  } = useDynamicPageInfo();
  const {
    hubDbTable
  } = useHubDbTable({
    hubDbTableId: hubDbTableId || dynamicPageHubDbTableId
  });
  if (!hubDbTable) {
    return null;
  }
  const tableName = hubDbTable.name || hubDbTable.label || /*#__PURE__*/_jsx(FormattedMessage, {
    message: "page-details-ui.header.missingValues.hs_dynamic_page_data_source_id"
  });
  return /*#__PURE__*/_jsx(Link, {
    external: true,
    href: getHubDbTableUrl(dynamicPageHubDbTableId),
    truncate: true,
    children: tableName
  });
};
const HubDbRowInfo = ({
  contentObject,
  rowPropertyName
}) => {
  const dynamicPageHubDbTableId = getContentDynamicPageHubDbTableId(contentObject);
  const {
    hubDbTableId,
    hubDbRowId
  } = useDynamicPageInfo();
  const {
    hubDbRow
  } = useHubDbRows({
    hubDbTableId: hubDbTableId || dynamicPageHubDbTableId,
    hubDbRowId
  });
  if (!hubDbRow) {
    return null;
  }
  return hubDbRow[rowPropertyName];
};
export const HubDbRowPath = ({
  contentObject
}) => {
  return /*#__PURE__*/_jsx(HubDbRowInfo, {
    contentObject: contentObject,
    rowPropertyName: "path"
  });
};
export const HubDbRowName = ({
  contentObject
}) => {
  return /*#__PURE__*/_jsx(HubDbRowInfo, {
    contentObject: contentObject,
    rowPropertyName: "name"
  });
};